import notificationDecorator from '../modules/Notifications/notificationDecorator';
import { intlShape } from '../components/base/IntlProviderWrapper';
import { getResponseError } from './utils';

export const processFormError = response => {
  const {
    formatMessage,
  } = intlShape;

  if (!response) {
    return 'Сервер не вернул тело ошибки.';
  }

  if (response instanceof Error) {
    window.console.error(response.message);
    notificationDecorator({
      title: formatMessage({ id: 'app.error.title' }),
      message: response.message || formatMessage({ id: 'app.unknown.error' }),
      isError: true,
    });

    return response.message || formatMessage({ id: 'app.unknown.error' });
  }

  return getResponseError(response, formatMessage({ id: 'app.unknown.error' }));
};
